'use strict';

var _ = require('underscore'),
    DelayActionMixin = require('./DelayActionMixin');

var DELAY_AFTER_RESIZE_EVENT = 1000,
    MEDIA_QUERIES;

// See atoms/media_queries.less

MEDIA_QUERIES = [{
  'key': 'default',
  'query': 'only screen'
}, {
  'key': 'xs',
  'query': 'only screen and (min-width: 30em)'
}, {
  'key': 'sm',
  'query': 'only screen and (min-width: 40em)'
}, {
  'key': 'md',
  'query': 'only screen and (min-width: 62em)'
}, {
  'key': 'lg',
  'query': 'only screen and (min-width: 75em)',
}, {
  'key': 'xl',
  'query': 'only screen and (min-width: 100em)'
}].reverse();

function validateImageSizes(imageSizes) {
  if (!imageSizes) {
    throw new Error('You need to define imageSizes to use ResponsiveImageMixin');
  }

  var allKeys = _.pluck(MEDIA_QUERIES, 'key'),
      definedKeys = _.keys(imageSizes);

  if (_.difference(allKeys, definedKeys).length) {
    throw new Error('Not all media keys are defined');
  }
}

/**
 * Provides an image size that matches current window size.
 *
 * The sizes for different width breakpoints can be defined
 * by providing `getImageSizes` method.
 */
var ResponsiveImageMixin = {
  mixins: [DelayActionMixin],

  getInitialState: function () {
    return {
      imageSize: this._findMatchingSize()
    };
  },

  getImageSize: function () {
    return this.state.imageSize;
  },

  componentWillMount: function () {
    window.addEventListener('resize', this._handleWindowResize);
  },

  componentWillUnmount: function () {
    window.removeEventListener('resize', this._handleWindowResize);
  },

  _handleWindowResize: function () {
    if (!this.isMounted()) {
      return;
    }

    this.scheduleAction(this._updateImageSize, DELAY_AFTER_RESIZE_EVENT);
  },

  _updateImageSize: function () {
    var imageSize = Math.max(this.state.imageSize, this._findMatchingSize());

    this.setState({
      imageSize: imageSize
    });
  },

  _findMatchingSize: function () {
    var imageSizes = this.getImageSizes(),
        mediaQuery;

    if ('production' !== process.env.NODE_ENV) {
      validateImageSizes(imageSizes);
    }

    mediaQuery = _.find(MEDIA_QUERIES, function (mediaQuery) {
      return window.matchMedia(mediaQuery.query).matches;
    });

    return imageSizes[mediaQuery.key];
  }
};

module.exports = ResponsiveImageMixin;


/** WEBPACK FOOTER **
 ** ./mixins/ResponsiveImageMixin.js
 **/